<template lang="html">
  <div id="terms" class="terms row">
    <div class="col-sm-12 text-center">
      <span class="tersm-text"><input type='checkbox' v-model='siteTerms' />{{translation.button.agreeTerms}}</span>
      <span class="tersm-text" @click="showModalGdpr">
        <span class="header-links text-left terms-links">
          <router-link :to="{name:'privacy-policy', params:{ lang: lang}}" target='_blank'>{{translation.button.gdprTitle}}</router-link>
        </span>
        <span>{{' '+ translation.button.and +' '}}</span>
        <span class="header-links text-left terms-links">
          <router-link :to="{name:'general-terms', params:{ lang: lang}}" target='_blank'>{{translation.generalTerms.button}}</router-link>
        </span>
      </span>
      <div>
        <button type="submit" class="btn btn-primary registration-button" :disabled='isDisabled'>{{translation.header.registration}}</button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Terms',
  data(){
    return {
      translation: null,
      siteTerms: false,
      showModalBody:false,
      lang: window.lang
    }
  },
  computed: {
  	isDisabled: function(){
      return !this.siteTerms;
    }
  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
  },
  methods:{
    showModalGdpr() {
      if (this.showModalBody) {
        this.showModalBody = !this.showModalBody;
      }else {
        this.showModalBody = !this.showModalBody;
      }

    }
  }
}
</script>
<style>

  .terms .tersm-text{
    font-size: .8em;
  }
  .terms .terms-links{
    display: inline-block;
    color: #3057B0;
    text-decoration: underline;
  }
  .terms .terms-links:hover{
    cursor: pointer;
  }
  #terms{
    background: #fff;
    margin-bottom: 3em;
  }
  #terms h3{
    text-align: center;
  }
  #terms h4{
    margin-top: 2em;
  }
  #terms {
    text-align: left;
  }
  #terms .font-italic {
    font-style: italic;
  }
  #terms input[type=checkbox] {
    display: inline-block!important;
    width: 2em!important;
    transform: scale(1.2)!important;
    border: none!important;
  }
  #terms .registration-button{
      background: #A8A8A8;
      padding-left: 1em;
      padding-right: 1em;
      border: none;
      outline: none;
      border-radius: 5em;
      margin-top: 1em;
      margin-bottom: 1em;
    }
    #doctor-registration #terms .registration-button{
        background: #FE7154;
      }
      #doctor-registration #terms .registration-button{
        background: #FE7154;
      }
</style>
